/* eslint-disable ember/no-computed-properties-in-native-classes */
import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { dynamicField } from '@linc-technologies/linced-common/utils/dynamic-fields';

// Proto: enrolments.Contact.
export default class Contact extends DynamicFieldsFragment {
  declare [Type]: 'enrolments/contact';

  @attr('number', { defaultValue: 0 })
  declare type: number;

  @attr('number', { defaultValue: 0 })
  declare relationship: number;

  @attr('number', { defaultValue: 0 })
  declare medicalRelationship: number;

  @attr('boolean', { defaultValue: false })
  declare permissionToContact: boolean;

  @attr('string', { defaultValue: '' })
  declare notes: string;

  @attr('boolean', { defaultValue: false })
  declare receivesSms: boolean;

  @attr('boolean', { defaultValue: false })
  declare billPayer: boolean;

  @attr('string', { defaultValue: '' })
  declare caregiverId: string;

  @dynamicField('core:firstName', DataType.STRING)
  declare firstName: string | undefined;

  @dynamicField('core:lastName', DataType.STRING)
  declare lastName: string | undefined;

  @computed('firstName', 'lastName')
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}
